











import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { LineGraphInterface } from '@/interfaces/LineGraphInterface';
// @ts-ignore
import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';

// @ts-ignore
FusionCharts.options.creditLabel = false;

// register VueFusionCharts component
Vue.use(VueFusionCharts, FusionCharts, Charts, FusionTheme);

@Component
export default class LineGraph extends Vue {

    @Prop() protected chartData!: LineGraphInterface;
    @Prop() protected lineColor!: string;

    private get trendLines() {
        if (this.chartData.trendLines.length < 0) {
            return [];
        }
        return [
            {
                line: this.chartData.trendLines.map((trendLine) => {
                    return {
                        startvalue: trendLine.startValue,
                        color: '#1e91d6',
                        displayvalue: trendLine.displayValue,
                        valueOnRight: '1',
                        dashed: '1',
                        thickness: '2',
                        dashGap: '8',
                        dashLen: '8',
                    };
                }),
            },
        ];
    }

    protected dataSource = {
        chart: {
            caption: this.chartData.chartCaption,
            yAxisName: this.chartData.yAxisName,
            lineThickness: '2',
            theme: 'fusion',
            numbersuffix: this.chartData.suffix ? this.chartData.suffix : '%',
            lineColor: this.lineColor,
            anchorRadius: '4',
            anchorBorderThickness: '2',
            outCnvBaseFontColor: '#354052',
            baseFontColor: '#ffffff',
            toolTipBgColor: '#333f52',
            yAxisNameFontColor: '#333f52',
            plottooltext: `<strong>$value${this.chartData.suffix ? this.chartData.suffix : '%'}</strong>`,
            showYAxisLine: true,
            yAxisLineColor: '#f2f2f2',
            toolTipBorderColor: '#333f52',
            captionAlignment: 'left',
            xAxisNameFontBold: '1',
            yAxisNameFontBold: '1',
        },
        data: this.chartData.data,
        trendlines: this.trendLines,
    };
    protected config = {
        type: 'line',
        width: '100%',
        height: '400',
        dataFormat: 'json',
    };

    @Watch('chartData') protected onChartDataChange() {
        // this.$forceUpdate();s
    }

}
